import { withMetadata } from 'src/gssp-wrappers/withMetadata'

const Home = () => {
  return <>Home Page</>
}

export const getServerSideProps = withMetadata({
  gsspCb: async context => {
    context.res.setHeader('Cache-Control', 'no-store, must-revalidate')

    return { props: {} }
  }
})

export default Home
